import React from 'react';
import { Stack, Box, Button } from '@mui/material';
import routes from '../../../routers/routes';
import FileViewer from '../../../components/FileViewer';
import { useNavigate } from 'react-router-dom';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import Image from '../../../components/Image';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const buttons = [
  {
    id: 1,
    label: 'Convocatoria',
    ariaLabel: 'Ver documento Convocatoria',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/Li%CC%81deres+en+Movimiento+Convocatoria+2026.pdf',
    type: 'PDF',
  },
  {
    id: 2,
    label: 'Preguntas Frecuentes',
    ariaLabel: 'Ver documento de prequntas frecuentes',
    src: 'https://s3.us-east-1.amazonaws.com/lideresenmovimiento.s3/Li%CC%81deres+en+Movimiento+FAQ+2026.pdf',
    type: 'PDF',
  },
];

export default function Convocatoria() {
  const [open, setOpen] = React.useState(false);
  let navigate = useNavigate();
  // const [openA, setOpenA] = React.useState(true);
  const [selectedFile, setSelectedFile] = React.useState(null);

  const handleOpenFile = (button) => {
    setSelectedFile(button);
    setOpen(true);
  };

  const handleGoToApplication = () => {
    navigate(routes.lemU);
  };

  const requisitos = [
    'Poseer liderazgo, motivación, compromiso e interés por aprender y desarrollar habilidades socioemocionales y cognitivas.',
    'Ser estudiante regular de cualquier carrera,matriculado(a) en una institución de educación superior, pública o privada.',
    'Tener un promedio acumulado hasta el periodo inmediato anterior mínimo de 7.0. Esto debe coincidir con la constancia académica solicitada.',
    'Tener entre 18 y 35 años al último día de la presente convocatoria.',
    'No estar postulando ni postular (durante la vigencia del programa LeM Universitarios) a otro programa que se desarrolle en las mismas fechas o que evite, por cualquier motivo, que el o la estudiante cumpla a cabalidad sus tareas asignadas.',
  ];

  return (
    <Stack
      alignItems="center"
      component="section"
      aria-labelledby="convocatoria-titulo"
      sx={{
        py: 5,
        px: '5%',
        flexGrow: 1,
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      <Stack sx={{ maxWidth: '1200px', width: '100%', boxSizing: 'border-box' }}>
        <Box
          component="h4"
          sx={{ typography: 'h4', fontWeight: 'bold', color: '#3E3D3D', mt: 2 }}
          id="convocatoria-titulo"
        >
          Consulta la convocatoria oficial de esta edición y las preguntas más frecuentes sobre el programa
        </Box>
        {buttons.map((button) => (
          <Button
            key={`file${button.id}`}
            sx={{ mt: 2 }}
            variant="outlined"
            aria-label={button.ariaLabel}
            onClick={() => handleOpenFile(button)}
          >
            {button.label}
          </Button>
        ))}
        <Button sx={{ mt: 2 }} variant="contained" onClick={handleGoToApplication}>
          Conoce más sobre LEM U
        </Button>
        {open && (
          <FileViewer
            open={open}
            setOpen={setOpen}
            src={selectedFile.src}
            label={selectedFile.label}
            type={selectedFile.type}
          />
        )}
      </Stack>
      <Stack sx={{ mt: 2 }}>
        <Accordion sx={{ backgroundColor: '#268c83', color: 'white' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box sx={{ fontSize: '20px', fontWeight: 'bold' }}>Requisitos</Box>
          </AccordionSummary>
          <AccordionDetails>
            <Stack component="ol" sx={{ textAlign: 'left' }} spacing={2}>
              {requisitos.map((req, index) => (
                <Stack direction="row" spacing={1} key={`req-${index}`}>
                  <Box sx={{ fontWeight: 'bold' }}>{index + 1}.</Box>
                  <Box sx={{ ml: 2 }}>{req}</Box>
                </Stack>
              ))}
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Stack>
      <Image
        sx={{ maxWidth: '1200px', objectFit: 'contain' }}
        mt={2}
        src="https://s3.amazonaws.com/lideresenmovimiento.s3/componentes20252.png"
        alt="Componentes Universitarios"
        aria-label="Componentes Líderes en Movimiento Universitarios - Cursos en Línea, Jornadas Académicas, Seminarios, Desafio prácticos, Sesiones de Mentoría, Conociendo a empresas, y viaje internacional."
        allowFullScreen
      />
    </Stack>
  );
}
